import constantFactory from "@gaoding/constant-factory";

export const {
  PIN_MATERIAL_STATUS,
  PIN_MATERIAL_STATUS_LIST,
  PIN_MATERIAL_STATUS_MAP,
  PIN_MATERIAL_STATUS_ITEM_MAP,
} = constantFactory("PIN_MATERIAL_STATUS", [
  {
    key: "UNAVAILABLE",
    label: "待上架",
    value: 1,
  },
  {
    key: "AVAILABLE",
    label: "已上架",
    value: 2,
  },
  {
    key: "OFFLINE",
    label: "已下架",
    value: 3,
  },
  {
    key: "DEBUGGER",
    label: "调试",
    value: 4,
  },
  {
    key: "DELETE",
    label: "删除",
    value: 5,
  },
  {
    key: "MODIFIED",
    label: "删除后上架",
    value: 6,
  },
]);
